import { forwardRef } from 'react';
import type { ReactNode } from 'react';
import { Button } from '../../ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../ui/tooltip';
import { PopoverTrigger } from '../../ui/popover';
import { CountBadge } from '../../../shared/components/common/CountBadge';

interface AppBarBadgeButtonProps {
  icon: ReactNode;
  count: number;
  ariaLabel: string;
  tooltip: string;
  moduleColor: string;
}

export const AppBarBadgeButton = forwardRef<HTMLButtonElement, AppBarBadgeButtonProps>(
  function AppBarBadgeButton({ icon, count, ariaLabel, tooltip, moduleColor }, ref) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <Button
              ref={ref}
              variant="ghost"
              size="icon"
              className="relative hover:bg-accent"
              style={{ color: moduleColor }}
              aria-label={ariaLabel}
            >
              {icon}
              {/* The button's own aria-label names the surface, so the badge stays
                  silent — CountBadge hides itself when given no ariaLabel. */}
              <CountBadge count={count} className="absolute -top-0.5 -end-0.5" />
            </Button>
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    );
  },
);
